export const correctionPiecesData = [
    {
        id: 1,
        name: "Pièce A",
        inspector: "Jean Dupont",
        status: "En correction",
    },
    {
        id: 2,
        name: "Pièce B",
        inspector: "Marie Curie",
        status: "En correction",
    },
    {
        id: 3,
        name: "Pièce C",
        inspector: "Paul Martin",
        status: "En correction",
    },
];
